import Button from '@mui/material/Button'
import Snackbar from '@mui/material/Snackbar'
import SnackbarContent from '@mui/material/SnackbarContent'
import type { StyleObjectWithTheme } from '@/core/App/theme'
import useTheme from '../hooks/useTheme'

function Popup(props: any) {
	const { message, action, button, toggleVisibility, visible: isVisible } = props

	const theme = useTheme()
	const styles = stylesheet(theme)

	return (
		<Snackbar
			anchorOrigin={{
				horizontal: 'right',
				vertical: 'top',
			}}
			autoHideDuration={600000}
			open={isVisible}
		>
			<SnackbarContent
				action={[
					<Button color="primary" css={styles.button} key="refresh" onClick={action} size="small" variant="contained">
						{button || 'Action'}
					</Button>,

					<Button color="primary" css={styles.close} key="close" onClick={toggleVisibility} size="small">
						HIDE
					</Button>,
				]}
				css={styles.snackbarContent}
				message={<span css={styles.message}>{message}</span>}
			/>
		</Snackbar>
	)
}

const stylesheet: StyleObjectWithTheme = () => ({
	button: {
		'& span': {
			lineHeight: '1rem',
		},
		marginRight: '0.5rem',
	},
	close: {
		color: '#47AAE5',
		height: '100%',
		width: 'auto',
	},

	icon: {
		color: 'black',
	},

	message: {
		color: 'black',
	},

	snackbarContent: {
		backgroundColor: 'white',
		maxWidth: 'initial',
	},
})

export default Popup
